import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMetaMask } from '../context/MetaMaskContext';
import { ethers } from 'ethers';
import MyToken1155Artifacts from '../artifacts/contracts/MyToken1155.sol/MyToken1155.json';
import { MyToken1155 } from '../@types/contracts/MyToken1155';

// import toast from 'react-hot-toast';

type ModalPurchaseNFTProps = {
  isOpen: boolean;
  toggle(): void;
  tiers: Tier[];
  selectedNFTIndex: number;
};

const ModalPurchaseNFT: FC<ModalPurchaseNFTProps> = ({ isOpen, toggle, tiers, selectedNFTIndex }) => {
  const { metaMask } = useMetaMask();

  const [purchaseItemQuantity, setPurchaseItemQuantity] = useState<number[]>([]);

  useEffect(() => {
    if (!tiers) return;

    const init = Array(tiers.length).fill(1);

    setPurchaseItemQuantity(init);
  }, [tiers]);

  const changeQuantity = (index: number, value: string) => {
    const arr = [...purchaseItemQuantity];
    arr[index] = Number(value.replace(/[^0-9]/g,''));

    setPurchaseItemQuantity(arr);
  };

  const validateForm = () => {
    const signedArr = purchaseItemQuantity.filter((item) => item < 1);

    if (signedArr.length > 0) {
      return false;
    }

    return true;
  };

  const purchaseNFT = async () => {
    if (!metaMask.isConnected || !metaMask.addressNFT1155 || !metaMask.account || !metaMask.chainId) {
      return;
    }

    try {
      const provider = new ethers.providers.Web3Provider(metaMask.provider);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(metaMask.addressNFT1155, MyToken1155Artifacts.abi, signer) as MyToken1155;

      let total = 0;

      const purchaseItems = tiers.map((item, index) => {
        total += Number(item.price) * purchaseItemQuantity[index];
        return { tokenId: item.tokenId || 0, quantity: purchaseItemQuantity[index] };
      });

      const overrides = {
        value: ethers.utils.parseEther(`${total}`), //sending one ether
        gasLimit: 500000, //optional
      };

      const transaction = await contract.purchase(purchaseItems, overrides);

      transaction
        .wait()
        .then((res: any) => {
          console.log({ res });
        })
        .catch((error) => console.error(error));

      toggle();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-purchase">
        <ModalHeader toggle={toggle}>Buy token</ModalHeader>
        <ModalBody>
          <div>
            {tiers.map((item, index) => (
              <div key={index}>
                <div
                  style={{
                    margin: '10px 0px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <img
                      width="50px"
                      height="50px"
                      src={`https://xyz-project-bucket.s3.us-west-2.amazonaws.com/${item?.fileName}`}
                    />
                  </div>
                  <div style={{ marginLeft: 15 }}>{item.name}</div>
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <input
                      type="number"
                      min="1"
                      step="1"
                      value={purchaseItemQuantity[index] || ''}
                      style={{
                        boxSizing: 'border-box',
                        backgroundColor: 'transparent',
                        width: 60,
                        height: 30,
                        outline: 'none',
                        border: '1px solid #464a4d',
                        borderRadius: 5,
                        color: 'inherit',
                        paddingRight: 8,
                        textAlign: 'left',
                      }}
                      onChange={(e) => changeQuantity(index, e.target.value)}
                    ></input>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className={validateForm() ? 'app-btn color-primary' : 'app-btn color-primary disable'}
            onClick={() => purchaseNFT()}
          >
            Buy
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalPurchaseNFT.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ModalPurchaseNFT.defaultProps = {
  toggle: () => {},
};

export default ModalPurchaseNFT;
